import Entity from './entity'
export default class annualmanagementplan extends Entity<number>{
    enterpriseinformationid:number;
    customizeddate:Date;
    startdate:Date;
    enddate:Date;
    annualManagementPlanDetails:Array<Object>;
    

    
}